import React from "react";
import { connect } from "react-redux";
import { Modal, Form, message, Button, Icon,DatePicker,TimePicker,Input,Tooltip,Select,Spin, Radio, TreeSelect } from 'antd';

import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicTable from "../../components/frame/DynamicTable";

import DynamicFilter from "../../components/frame/DynamicFilter";
import ReactAbstract from "../../components/abstract/React.abstract";
import OvertimeApprovalService from "../../services/Approval/overtime-approval-service";
import { fetchDepartmentsList } from '../../actions/department-structure-actions';
import { fetchLeaveType } from '../../actions/employee-actions';
import { fetchEmployeesList } from '../../actions/employee-management-actions.js';
import debounce from 'lodash.debounce';
import applicationCenterService from '../../services/Employee/application-center-service';

const { TextArea } = Input;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
class OvertimeManage extends ReactAbstract {

	constructor (props) {
        super(props)
        // 使用 debounce 函数来节流 以 避免 onchange事件的频繁触发 导致页面的频繁重绘
        this.fetchUserList = debounce(this.fetchUserList, 800);
        this.state={
        	currentModalStatus: false,
			currentIndex: null,
			currentData: {},
			currentDataStatus: "unload",
			filters: {},
			data: [],
			dataStatus: "unload",
			typeTag: '1'
        }
    }

	customComponentWillMount(){
		this.props.fetchDepartmentsList();
		this.props.fetchLeaveType();
		this.props.fetchEmployeesList();
	}

	dataMode = 1
	initReload = false
	moduleName = "attendance"
	childModuleName = "LeaveManage"

	// state = {
	// 	currentModalStatus: false,
	// 	currentIndex: null,
	// 	currentData: {},
	// 	currentDataStatus: "unload",
	// 	filters: {},
	// 	data: [],
	// 	dataStatus: "unload",
	// }

	actions = {
		selectAction: OvertimeApprovalService.selectOvertimeApprovalManage,
		createAction: OvertimeApprovalService.createOvertimeApproval,
		updateAction: OvertimeApprovalService.updateOvertimeApproval,
		deleteAction: OvertimeApprovalService.deleteOvertimeApproval,
		exportAction: OvertimeApprovalService.exportOvertimeApproval
	}


	filterColumn = [{
			type: "person",
			label:"姓名或工号"
		}, {
			type: "department"
		}, {
			type: "date",
			label: "结束时间",
			key: "search_end_time",
		}, {
			type: "date",
			label: "开始时间",
			key: "search_start_time",
		}
	]

	tableColumn = [{
			title: '工号',
			dataIndex: 'job_number',
			key: 'job_number',
			className: 'table-global-head-small'
		},{
			title: '中文名',
			dataIndex: 'real_name',
			key: 'real_name',
			className: 'table-global-head-small'
		}, {
			title: '英文名',
			dataIndex: 'english_name',
			key: 'english_name',
			className: 'table-global-head'
		}, {
			title: '部门名称',
			dataIndex: 'department_name',
			key: 'department_name',
			className: 'table-global-head'
		}, {
			title: '加班日期',
			dataIndex: 'overtime_date_str',
			key: 'overtime_date_str',
			className: 'table-global-head-short'
		}, {
			title: '开始时间',
			dataIndex: 'start_time',
			key: 'start_time',
			className: 'table-global-head-short'
		}, {
			title: "结束时间",
			dataIndex: 'end_time',
			key: 'end_time',
			className: 'table-global-head-short'
		}, {
			title: "时长",
			dataIndex: 'overtime_hours',
			key: 'overtime_hours',
			className: 'table-global-head-small'
		}, {
			title: "加班类型",
			dataIndex: 'overtime_type_str',
			key: 'overtime_type_str',
			className: 'table-global-head-small'
		}, {
			title: '加班原因',
			dataIndex: 'remark',
			key: 'remark',
			className: 'table-global-head'
		}, {
			title: '状态',
			dataIndex: 'approval_status_str',
			key: 'approval_status_str',
			className: 'table-global-head-small'
		}
	]

	insertCurrent = () => {
		this.setState({currentModalStatus: true});
		// insert
		this.setState({
			currentData: {},
			typeTag: '1'
		});
	}
	publicDelete = () => {
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error('请选择要删除的内容', 4);
			return false;
		}
		Modal.confirm({
			title: '确定删除选中的内容么?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				if ("function" === typeof this.actions.deleteAction) {
					this.actions.deleteAction({ids: this.state.selectedIDs}, res => {
						if (res.data.Success) {
							this.setState({selectedIDs: []});
							message.success('删除操作成功', 4);
							this.publicChange();
						}else{
							message.error('删除操作失败' + res.data.Errors[0], 4);
						}
					});
				}else{
					this.handleError('undefined delete action');
				}
			},
			onCancel: () => {}
		});
	}
	fetchUserList = (params) => {
        this.props.fetchEmployeesList(params)
    }

	handleSearchChange = value => this.props.fetchEmployeesList({real_name: value})

    selectViewer =(value, obj) =>{
		this.setState({
          charge_user_ids: obj.props.data,
          charge_user_names: value
        });
	}

	handleSelectChange = (v) => {
        this.setState({
            groupUser: v
        })
    }

    submitCurrentModal = () => {
		// submit
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let posts = {
					...values
				};
				if (values.overtime_date){
					posts.overtime_date = values.overtime_date.format('YYYY-MM-DD')
				}
				if (values.start_time){
					posts.start_time = values.start_time.format('HH:mm')
				}
				if (values.end_time){
					posts.end_time = values.end_time.format('HH:mm')
				}
				
				console.log(posts);
				applicationCenterService.overtimeManager(posts, res => {
					if (res.data.Success) {
						message.success("新增加班操作成功", 4);
						this.props.form.resetFields();
						this.setState({currentModalStatus: false});
						this.publicChange({}, "reload")	
					}else{
						message.error(`新增加班操作失败：${res.data.Errors[0]}`);
					}
				}, err => {});
			}
		})
	}

	changeAllMember = (v) =>{
		console.log(v.target.value);
		this.setState({
            typeTag: v.target.value
        })
	}
	renderTreeNodes = data => data.map(item => {
	    if (item.children) {
	      return (
	        <TreeSelect.TreeNode title={item.name} 
	          value={item.id}
	          key={item.id}
	          dataRef={item} >
	          {item.children.length !== 0 && this.renderTreeNodes(item.children)}
	        </TreeSelect.TreeNode>
	      )
	    }
	    return <TreeSelect.TreeNode {...item} />
	 })

	render () {
		// const { employeeLeaveType } = this.props.employee;
		return (
			<div className="app-module-item">
				<div className="app-module-header">
					<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.insertCurrent}>
							<Icon type="plus-circle-o" />
							<span>新增</span>
						</Button>
					</div>
					<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicDelete}>
							<Icon type="delete-circle-o" />
							<span>批量删除</span>
						</Button>
					</div>
					<div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicExport}>
							<Icon type="cloud-download-o" />
							<span>导出</span>
						</Button>
					</div>
					<DynamicFilter column={this.filterColumn}
						departmentsList={this.props.departmentStructure.departmentsList}
						value={this.dataSource().filters}
						setFilter={this.publicChange} />
				</div>
				<Modal width="800px"
					visible={this.state.currentModalStatus}
					title="新增加班"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.submitCurrentModal}  className="LeaveManageForm">
					<div className="Applys">
						<Form.Item label={(
				            <span>
				              <Tooltip>
				                <Icon type="tag" />
				              </Tooltip>
				              &nbsp;选择类型
				            </span>
				          )}>
							<RadioGroup defaultValue={this.state.typeTag} onChange={this.changeAllMember.bind(this)}>
								<RadioButton value="1">全部员工</RadioButton>
								<RadioButton value="2">当前部门</RadioButton>
							</RadioGroup>
						</Form.Item>
						{this.state.typeTag==='1'&&<Form.Item label={(
				            <span>
				              <Tooltip>
				                <Icon type="user" />
				              </Tooltip>
				              &nbsp;加班员工
				            </span>
				          )}>
							{this.props.form.getFieldDecorator('employee_ids', {
								rules: [{ required: true, message: '请选择员工' }],
							})(<Select
								  mode="multiple"
								  filterOption={false}
								  style={{ width: 360 }}
								  notFoundContent={this.props.employeeManagement.fetching ? <Spin size="small" /> : null}
								  placeholder="请选择员工"
								  onSearch={this.handleSearchChange}
								  onSelect={this.selectViewer}
								  onChange={this.handleSelectChange}>
								  {this.props.employeeManagement.employeeList && this.props.employeeManagement.employeeList.Data instanceof Array &&
				                      this.props.employeeManagement.employeeList.Data.map(employee => {
				                      return (
				                        <Select.Option key={employee.id} value={employee.id}
				                           style={{width:"340px"}}>
				                          {employee.real_name}
				                        </Select.Option>)
				                    })}
							</Select>)}
						</Form.Item>}
						{this.state.typeTag==='2'&&<Form.Item label={(
				            <span>
				              <Tooltip>
				                <Icon type="team" />
				              </Tooltip>
				              &nbsp;请假部门
				            </span>
				          )}>
							{this.props.form.getFieldDecorator('department_id', {
								rules: [{ required: true, message: '请选择部门' }],
							})(<TreeSelect style={{width:"360px"}}
                              allowClear
                              placeholder="请选择部门"
                              showSearch={false}
                              autoExpandParent={true}
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              treeDefaultExpandAll
                              >
                              {this.renderTreeNodes(this.props.departmentStructure.departmentsList)}
                            </TreeSelect>)}
						</Form.Item>}
										
					</div>
					<div className="">
						<Form.Item label={(
				            <span>
				              <Tooltip>
				                <Icon type="question-circle-o" />
				              </Tooltip>
				              &nbsp;加班类型
				            </span>
				          )}>
							{this.props.form.getFieldDecorator('overtime_type', {
								rules: [{ required: true, message: '请选择加班类型' }],
							})(<Select style={{width:"360px"}} onSelect={this.selectCertificate}>
								<Select.Option key={1} value={1} data="普通加班">普通加班</Select.Option>
								<Select.Option key={2} value={2} data="因公加班">因公加班</Select.Option>
							</Select>)}
						</Form.Item>
					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
				            <span>
				              <Tooltip>
				                <Icon type="calendar" />
				              </Tooltip>
				              &nbsp;加班日期
				            </span>
				          )} style={{float:"left"}}>
							{this.props.form.getFieldDecorator('overtime_date', {
								rules: [{ required: true, message: '请输入加班开始日期' }],
							})(<DatePicker style={{width:"360px"}} />)}
						</Form.Item>
						
					</div>
					<div className="ApplyDiv">
						<Form.Item label={(
				            <span>
				              <Tooltip>
				                <Icon type="clock-circle-o" />
				              </Tooltip>
				              &nbsp;加班时间
				            </span>
				          )} style={{float:"left"}}>
							{this.props.form.getFieldDecorator('start_time', {
								rules: [{ required: true, message: '开始时间' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{width:"162px"}} />)}
						</Form.Item>
						<span className="ApplyTimes">至</span>
						<Form.Item lable=" " style={{float:"left",marginTop:"4px"}}>
							{this.props.form.getFieldDecorator('end_time', {
								rules: [{ required: true, message: '结束时间' }],
							})(<TimePicker minuteStep={30} format="HH:mm" style={{width:"163px"}} />)}
						</Form.Item>
					</div>
					
					<div className="ApplyDiv">
						<Form.Item label={(
				            <span>
				              <Tooltip>
				                <Icon type="file-text" />
				              </Tooltip>
				              &nbsp;加班事由
				            </span>
				          )}>
							{this.props.form.getFieldDecorator('remark', {
								rules: [{ required: true, message: '请输入加班事由' }],
							})(<TextArea rows={4} style={{display:'block',width:'360px'}}/>)}
						</Form.Item>
					</div>
				</Modal>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.dataSource().dataStatus}
						dataSource={this.dataSource().data.Data}
						pagination={{
							total: this.dataSource().data.Total,
							pageSize: this.dataSource().data.PageSize,
							current: this.dataSource().filters.page}}
						rowSelection={this.rowSelection}
						setPageFilter={this.publicChange} />
				</div>
			</div>
		)
	}
}

OvertimeManage = Form.create()(OvertimeManage);

const mapStateToProps = state => {
	return {
		departmentStructure: state.departmentStructure,
		employee: state.employee,
		employeeManagement: state.employeeManagement
	}
}

const mapDispatchToProps = {
	fetchDepartmentsList,
	fetchLeaveType,
	fetchEmployeesList
}

OvertimeManage = connect(mapStateToProps, mapDispatchToProps)(OvertimeManage);

export default LayoutWrapper(OvertimeManage);


// WEBPACK FOOTER //
// ./src/routes/Attendance/OvertimeManage.js